export interface ProjectTypeSelectionDiff {
  addedIds: string[]
  removedIds: string[]
}

export function diffProjectTypeSelection(
  currentIds: string[] | undefined | null,
  selectedIds: string[] | undefined | null
): ProjectTypeSelectionDiff {
  const current = currentIds ?? []
  const selected = selectedIds ?? []

  return {
    addedIds: selected.filter((id) => !current.includes(id)),
    removedIds: current.filter((id) => !selected.includes(id))
  }
}
